/*
 * @Description: 
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2021-10-08 14:21:09
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-10-15 16:02:57
 */
const states = {
    currentTab:null,
    tabs: [
        {
            path: '/',
            name: 'home',
            meta:{
              title:"首页",
            },
            icon: 'home'
          } 
    ], 
};
export default states;


// WEBPACK FOOTER //
// ./src/store/modules/navigation/states/index.js